import { UserContractorContext } from '../models/UserContractorContext';
import { PDADataService } from '../../../../services/base/PDADataService';
import { CancelToken } from 'axios';
import { User } from '../models/User';
import { UpdateSapCodesRequest } from '../../../profile/models/UpdateSapCodesRequest';
import { ChildContractorUser } from '../../../users/models/ChildContractorUser';
import { ChildContractorUserRequest } from '../../../users/models/ChildContractorUserRequest';

export class UserService extends PDADataService {
    protected prefixUrl = `users`;

    getCurrentUserContext() {
        return this.api.get<UserContractorContext>(`${this.prefixUrl}/GetCurrentUserContext`);
    }

    searchNotificationUsers(query: string, take: number, cancelToken?: CancelToken) {
        return this.api.get<User[]>(`${this.prefixUrl}/SearchNotificationUsers`, {
            params: { query, take },
            cancelToken,
        });
    }

    updateSapCodes(request: UpdateSapCodesRequest) {
        return this.api.post(`${this.prefixUrl}/UpdateSapCodes`, request);
    }

    getChildUsers() {
        return this.api.get<ChildContractorUser[]>(`${this.prefixUrl}/GetChildUsers`);
    }

    getChildUser(id: number) {
        return this.api.get<ChildContractorUser>(`${this.prefixUrl}/GetChildUser?id=${id}`);
    }

    createChildUser(request: ChildContractorUserRequest) {
        return this.api.post<ChildContractorUser>(`${this.prefixUrl}/CreateChildUser`, request);
    }

    updateChildUser(request: ChildContractorUserRequest) {
        return this.api.post<ChildContractorUser>(`${this.prefixUrl}/UpdateChildUser`, request);
    }

    toggleBlockChildUser(id: number) {
        return this.api.put(`${this.prefixUrl}/ToggleBlockChildUser/${id}`);
    }

    changeOrganizationOwner(newOwnerUserId: number) {
        return this.api.post(`${this.prefixUrl}/ChangeOrganizationOwner/${newOwnerUserId}`);
    }
}
